var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",on:{"click":_vm.onClickIcon}},[_c('img',{attrs:{"src":_vm.iconPath,"alt":_vm.icon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }